import * as React from 'react';

export default function SEO({ data, children }) {
  const image = data?.socialMediaImage?.url || '';
  const title = data?.metadataTitle || data?.title;
  const description = data?.metadataDescription;
  const keywords = data?.metadataKeywords;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      <meta property="og:image" content={image} />
      <meta name="twitter:description" content={description} />
      {children}
    </>
  );
}
